import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { verifyEmail } from '../../http/userAPI';
import './EmailVerification.css';
import ClassicButton from '../../components/UI/ClassicButton/ClassicButton';


const EmailVerification: React.FC = () => {
    const [message, setMessage] = useState<string | null>(null);
    const location = useLocation();
    const navigate = useNavigate();
    const [isLoading, setLoading] = useState<boolean>(false);
    
    const query = new URLSearchParams(location.search);
    const token = query.get('token');
    
    useEffect(() => {
        if (token) {
            verifyEmail(token)
                .then((response) => {
                    if (Array.isArray(response)) {
                        setMessage(response.join(', '));
                    } else {
                        setMessage(response);
                    }
                    setLoading(false);
                })
                .catch((error) => {
                    setMessage('Ошибка подтверждения email');
                    setTimeout(() => {})
                    setLoading(false);
                });
        } else {
            setMessage('Ошибка подтвержденя почты. Попробуйте еще раз');
            setLoading(false);
        }
    }, [token]);
    
    return (
        <div className='emailVerification'>
            <div className='emailVerification_loading_wrapper'>
                {isLoading ? (
                    <div className='emailVerification_loading'>
                        <p className='emailVerification_loading_text'>Подтверждение email</p>
                    </div>
                ) : (
                    <p className='emailVerification_loading_text'>{message}</p>
                )}
                <div className='emailVerification_button'>
                    <ClassicButton 
                        onClick={() => navigate('/')}
                        bgColor='#ffe5cc'
                        fontSize='25px'
                        fontColor='#754737'
                        fontFamily='Actay Regular'
                        isLoading={isLoading}
                        innerLoaderSize='25px'
                        width='300px'
                        height='50px'
                    >На главную</ClassicButton>
                </div>
            </div>
        </div>
    );
};

export default EmailVerification;